import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import reportWebVitals from './reportWebVitals';
import GlobalContextProvider from './state/global/GlobalContextProvider'
import ApiLoader from './components/sharedComponents/ApiLoader';
import TrellisSnakbar from './components/sharedComponents/TrellisSnakBar';
import AppLoader from './components/sharedComponents/AppLoader';
import TheameComponent from './TheameComponent';
import './index.css';

ReactDOM.render(
  <Suspense fallback={<AppLoader />}>
    <React.StrictMode>
      <GlobalContextProvider>
        <TheameComponent />
        <ApiLoader />
        <TrellisSnakbar />
      </GlobalContextProvider>
    </React.StrictMode>
  </Suspense>
  ,
  document.getElementById('root')
);
console.log('prod build : 1.3.5')
// Register Service Worker 
// serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
//updated react-scripts version 4.0.3 to 5.0.0 on oct 10 2021
